import { Box, Flex } from '@mantine/core';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useGetCampaignQuery } from 'src/api/campaigns/hooks';
import { CampaignCalendar } from 'src/features/campaign/feature-campaign-details';
import { PageLoader } from 'src/components/PageLoader';
import { NotFound } from 'src/components/NotFound';
import { ActionFooter } from 'src/components/ActionFooter';
import { useCampaignDetails } from './use-campaign-details';

export const Campaign: FC = () => {
  const { id } = useParams<{ id: string; slotId?: string }>();
  const campaignId = id ? parseInt(id) : 0;

  const {
    data: campaign,
    isLoading,
    isError,
  } = useGetCampaignQuery(campaignId);

  const { handleEdit, handleDelete, handleCancel } =
    useCampaignDetails(campaignId);

  if (isLoading) {
    return <PageLoader visible={true} />;
  }

  if (isError || !campaign) {
    return <NotFound />;
  }

  return (
    <Flex direction="column" justify="space-between" style={{ height: '100%' }}>
      <Box>
        <CampaignCalendar data={campaign} />
      </Box>

      <ActionFooter
        showSubmitButton={false}
        onCancel={handleCancel}
        onDelete={handleDelete}
        onEdit={handleEdit}
        editButton="EDIT"
        deleteButton="DELETE"
        cancelButton="BACK"
      />
    </Flex>
  );
};
